import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { Connect, PropsFromRedux } from './LegalBasisSnippetContainer';
import styles from './legal_basis.module.scss';
import { LegalBasisSnippetItem } from './LegalBasisSnippetItem';
import { buildUrlWithParameters } from '../../../../../utils/url-utils/urlUtils';
import { doctrineAnalytics } from '../../../../../utils/analyticsUtils';
import { withUser } from '../../../../../user/UserContext';
import {
  withRestrictedModal,
  WithRestrictedModalProps,
} from '../../../../../components/modal/components/modal-restricted/withRestrictedModal';
import { UserContextType } from '../../../../../user/user.types';
import { AsideSearchSnippetHeader } from '../header/AsideSearchSnippetHeader';
import { TextHyperlink } from '../../../../../components/button';

type Props = PropsFromRedux & UserContextType & WithRestrictedModalProps;

const source = 'legal-basis-snippet';

export const RawLegalBasisSnippet: FC<Props> = ({
  legalBasis,
  query,
  searchQueryUrl,
  accessPremium,
  openRestrictedModal,
}) => {
  const legislationSearchUrl = buildUrlWithParameters('/search', {
    q: query,
    type: 'law',
  });

  if (!legalBasis || legalBasis.length === 0) {
    return null;
  }

  const reportOnOpenToNewTabAndBasicClick = () => {
    doctrineAnalytics('Search TypeOfResultChanged', {
      type: 'law',
      source: 'legal-basis-snippet',
    });
  };

  return (
    <div className={styles.container}>
      <AsideSearchSnippetHeader
        title={
          <FormattedMessage id="search/components/search-snippets/aside/legal-basis/LegalBasisSnippet.tsx/1" />
        }
      >
        <TextHyperlink
          {...(accessPremium
            ? {
                href: legislationSearchUrl,
                source,
                onMouseDown: reportOnOpenToNewTabAndBasicClick,
              }
            : {
                onClick: () => openRestrictedModal(source),
              })}
        >
          <FormattedMessage id="search/components/search-snippets/aside/legal-basis/LegalBasisSnippet.tsx/2" />
        </TextHyperlink>
      </AsideSearchSnippetHeader>
      {legalBasis.map((legislation, index) => {
        return (
          <div
            className={styles.legislation}
            // eslint-disable-next-line react/no-array-index-key
            key={`legal-basis-snippet-${index}`}
          >
            <LegalBasisSnippetItem
              searchQueryUrl={searchQueryUrl}
              legislation={legislation}
              source="legal-basis-snippet"
            />
          </div>
        );
      })}
    </div>
  );
};

export const LegalBasisSnippet = Connect(
  withUser(withRestrictedModal(RawLegalBasisSnippet)),
);
